import { gql } from '@apollo/client'

export const GetCustomers = gql`
  query GetCustomers {
    getCustomers {
      id
      firstname
      middlename
      lastname
      role
      isInvitationPending
      kycStatus
      sites {
        id
      }
    }
  }
`

export const GetCustomerWithSites = gql`
  query GetCustomerWithSites($customerUuid: ID!) {
    getCustomer(customerUuid: $customerUuid) {
      id
      entityUuid
      email
      emailVerified
      nickname
      firstname
      middlename
      lastname
      phone
      phoneVerified
      role
      address {
        country
        street
        suburb
        state
        postcode
      }
      registeringIndividual
      director
      secretary
      ceo
      beneficialOwner
      beneficialOwnerAlt
      beneficiary
      partner
      trustee
      settlor
      generalContact
      financialContact
      type
      companyTrustName
      abn
      productTourStatus {
        showAdminMerchantPortalWelcome
        showInvoiceInstructions
      }
      isInvitationPending
      kycStatus
      idvAttempts {
        driversLicence
        passport
        medicareCard
      }
      sites {
        id
        name
        devices {
          name
        }
      }
      permissions {
        allowZellerInvoices
        allowXeroPaymentServices
      }
    }
  }
`

export const GetCustomerPhone = gql`
  query GetCustomerPhone($customerUuid: ID!) {
    getCustomer(customerUuid: $customerUuid) {
      phone
    }
  }
`

export const GetCustomerReferralCode = gql`
  query GetCustomerReferralCode($customerUuid: ID!) {
    getCustomer(customerUuid: $customerUuid) {
      referralCode
    }
  }
`

export const GetCustomerDetails = gql`
  query GetCustomerDetails($customerUuid: ID) {
    getCustomer(customerUuid: $customerUuid) {
      id
      entityUuid
      firstname
      middlename
      lastname
      email
      phone
      role
      registeringIndividual
      sites {
        id
        name
        devices {
          name
        }
      }
      isInvitationPending
      kycStatus
      permissions {
        allowZellerInvoices
        allowXeroPaymentServices
      }
    }
  }
`
